import React, { Dispatch, useState } from 'react';
import { Col, Collapse, Form, Input, InputNumber, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../store';
import {
  cleanStateEstoque,
  filterEstoque,
  loadRequest,
} from '../../../../store/ducks/estoque/actions';
import FilterContainer from '../../../../components/FilterContainer';
import CollapseTitle from '../../../../components/TitleCollapseFilter';
import FilterBtn from '../../../../components/FilterBtn';
import ClearFilterBtn from '../../../../components/ClearFilterBtn';
import CollapseFilter from '../../../../components/CollapseFilter';
import SelectProduto from '../../../../components/SelectProduto';
import SelectPagadorArmazenagem from '../../../../components/SelectPagadorArmazenagem';
import {SelectParceiroDepositante} from '../../../../components/SelectParceiroDepositante';
import TextFilter from '../../../../components/TextFilter';
import SelectNumNota from '../../../../components/SelectNumNota';
import { ROLE } from 'utils/roles';
import { SelectDepositante } from 'components/SelectDepositante';

const { Panel } = Collapse;

const Filter: React.FC = () => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const pagCurrent = useSelector((state: ApplicationState) => state.Estoque.pagination.current);
  const sorter = useSelector((state: ApplicationState) => state.Estoque.sorter);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil)

  const [filter, setFilter] = useState<object | undefined | any>();
  const [prod, setProd] = useState<any>();
  // eslint-disable-next-line
  const [pagadorArmazenagem, setPagadorArmazenagem] = useState<any>();
  const dispatch = useDispatch<Dispatch<Action>>();

  const clearFilter = () => {
    setProd(null);
    dispatch(cleanStateEstoque());
    localStorage.removeItem(`pagadorArmazenagem${window.location.pathname}`);
    localStorage.removeItem(`produto${window.location.pathname}`);
    localStorage.removeItem(`depositante${window.location.pathname}`);
    localStorage.removeItem(`codDepositante${window.location.pathname}`);
    localStorage.removeItem(window.location.pathname + `valuesFilter`);
    dispatch(loadRequest({}, inscricaoAtiva, cddAtivo?.codCdd, sorter));
  };

  const onFilter = (values: any) => {
    localStorage.setItem(window.location.pathname + 'valuesFilter', JSON.stringify(values));

    if (prod) {
      const result = {
        ...values,
        codProduto: Number(prod),
      };
      const { ...rest } = result;

      setFilter({ ...rest });
      return;
    }
    setFilter(values);
  };

  const localStorageItensPersist: string = JSON.parse(
    localStorage.getItem(window.location.pathname + `valuesFilter`) || '{}'
  );

  return (
    <CollapseFilter
      filter={filter}
      pagination={pagCurrent}
      sorter={sorter}
      loadRequest={loadRequest}
      saveFilter={filterEstoque}
      saveLocalStorage={'persist:Estoque'}
    >
      <Panel header={<CollapseTitle>Filtro</CollapseTitle>} key="1">
        <FilterContainer onFilter={onFilter} initialValues={localStorageItensPersist}>
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <SelectProduto setProduto={setProd} />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectPagadorArmazenagem
                setPagArmazenagem={setPagadorArmazenagem}
                setFiltro={setFilter}
              />
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Lote</TextFilter>} name="controle">
                <Input id="controle" type="text" />
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Dias para vencer</TextFilter>} name="diasParaVencer">
                <InputNumber id="diasParaVencer" type="number" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              {perfil === ROLE.DEPOSITANTE
                ? <SelectParceiroDepositante />
                : <SelectDepositante />
              }
            </Col>
            <Col md={6} sm={24} xs={24}>
              <SelectNumNota label="Número da remessa" setNumNotas={() => { }} />
            </Col>
          </Row>
          <Row gutter={24} justify="end">
            <Col md={6} sm={24} xs={24}>
              <ClearFilterBtn onClick={clearFilter}>Limpar filtros</ClearFilterBtn>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <FilterBtn>Filtrar</FilterBtn>
            </Col>
          </Row>
        </FilterContainer>
      </Panel>
    </CollapseFilter>
  );
};

export default Filter;
